/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-11-16 10:57:07
 * @FilePath: \baishu_react_ui\src\components\dash\BsyDashDescription\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import BsyDashBase from "../BsyDashBase";
import { BsyUtils } from '../../../utils/Utils';
import "./index.css"

class BsyDashDescription extends BsyDashBase {
    constructor(props) {
        super(props)
        this.state = {
            style:{}
        }
    }

    componentDidMount() {
        // super.componentDidMount();
    }

    loadData = (n, d) => {
        BsyUtils.applyFunc(this, this.props.onLoadSuccess, [{}, n, d], !1)
    }

    render() {
        const {content} = this.props;
        let newstr = window.FX.Utils.replaceDescription(content)
        return (
            <div className="BsyDashDescription" dangerouslySetInnerHTML={{__html:newstr}} />
        );
    }
}

export default BsyDashDescription;